// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N30, N100A } from '@atlaskit/theme/colors';
import { gridSize, layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomModalHeader = styled.div({
	display: 'flex',
	position: 'relative',
	padding: `${token('space.150', '12px')} ${token('space.250', '20px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginBottom: `${gridSize() * 1.25}px`,
	borderBottom: `1px solid ${token('color.border', N30)}`,
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalBodyViewWrapper = styled.div({
	flexGrow: 1,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		padding: `${token('space.0', '0px')} ${token('space.250', '20px')}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalBodyEditWrapper = styled.div({
	flexGrow: 1,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		padding: token('space.0', '0px'),
		overflowY: 'hidden',
	},
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		width: 'calc(100vw - 120px)',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		padding: '1px', // needed to display border-radius in edit mode
	},
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
});

// this is an extra modal blanket covering everything behind our modal to
// darken it when an inner modal is being shown in the embedded component
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalOuterBlanket = styled.div({
	height: '100vh',
	width: '100vw',
	position: 'fixed',
	top: token('space.0', '0px'),
	left: token('space.0', '0px'),
	zIndex: layers.modal(),
	backgroundColor: token('color.blanket', N100A),
});

// this is a blanket on top of the components inside our modal but under the
// iframe, so it darkens just the right components when an inner modal is
// being shown in the embedded component
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ModalInnerBlanket = styled.div({
	height: '100%',
	width: '100%',
	position: 'absolute',
	top: token('space.0', '0px'),
	left: token('space.0', '0px'),
	zIndex: 0,
	backgroundColor: token('color.blanket', N100A),
});
